import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const PaymentDetails = ({ onClose, active, payment = {} }) => {
  return (
    <Modal open={active}>
      <Modal.Header>Payment details</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>Payment ID: {payment.id}</p>
          <p>Amount: {`${payment.amount} ${payment.currencyCode}`}</p>
          <p>Status: {payment.state}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        {payment.state === 'processing' && (
          <Button
            color="blue"
            onClick={() => window.location.replace(payment.details.return_url)}>
            Go to payment
          </Button>
        )}
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/payment/PaymentDetails.js